{
    "AppMenu_AppsTitle": "Menu",
    "AppMenu_Apps_Reporting": "Análises",
    "AppMenu_Apps_FastProvisioning": "Provisionamento rápido",
    "AppMenu_Apps_Administration": "Administração",
    "AppMenu_Apps_StatusAndTools": "Status e ferramentas",
    "AppMenu_FavouritesTitle": "Favoritos",
    "NAME": "AppMenu"
}